import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	Input,
	InputLabel,
	FormControl,
	withStyles,
	LinearProgress,
	FormHelperText,
	IconButton,
	Menu,
	MenuItem,
} from '@material-ui/core'
import { Add, MoreVert, Delete } from '@material-ui/icons'
import MaskedInput from 'react-text-mask'
import Button from 'components/theme/Button'
import {
	handleCustomAttributeChange,
	toggleCustomFieldHover,
	removeCustomAttribute,
	openAddDetailsModal,
} from 'actions/contacts/addOrEdit'
import { createOrUpdateContact } from 'actions/contacts'
import { withRouter } from 'react-router-dom'
import language from 'utils/vast-languagepack'

const TextMaskCustom = (props) => {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={inputRef}
			mask={[
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
				/\d/,
			]}
			placeholderChar={'\u2000'}
			showMask
		/>
	)
}

export default withRouter(
	connect(
		(state) => ({
			customAttributes: state.addOrEditContact.fields.custom_attributes,
			error: Object.keys(
				state.addOrEditContact.fields.custom_attributesError,
			).join(', '),
		}),
		(dispatch) =>
			bindActionCreators(
				{
					onChange: handleCustomAttributeChange,
					toggleHover: (customAttribute) =>
						toggleCustomFieldHover(customAttribute),
					openAddDetailsModal,
					createOrUpdateContact,
					removeCustomAttribute,
				},
				dispatch,
			),
	)(
		withStyles((theme) => ({
			textField: {
				marginLeft: theme.spacing.unit,
				marginRight: theme.spacing.unit,
			},
			formControlMargin: {
				marginTop: '16px',
				marginBottom: '8px',
			},
			cssFocused: {},
			'cssLabel-#920505': {
				'&$cssFocused': {
					color: '#920505',
				},
			},
			'cssUnderline-#920505': {
				'&:after': {
					borderBottomColor: '#920505',
				},
			},
			'cssInput-#920505': {
				color: '#920505',
			},

			'cssLabel-#EE6237': {
				'&$cssFocused': {
					color: '#EE6237',
				},
			},
			'cssUnderline-#EE6237': {
				'&:after': {
					borderBottomColor: '#EE6237',
				},
			},
			'cssInput-#EE6237': {
				color: '#EE6237',
			},

			'cssLabel-#CDB83D': {
				'&$cssFocused': {
					color: '#CDB83D',
				},
			},
			'cssUnderline-#CDB83D': {
				'&:after': {
					borderBottomColor: '#CDB83D',
				},
			},
			'cssInput-#CDB83D': {
				color: '#CDB83D',
			},

			'cssLabel-#5DCD3E': {
				'&$cssFocused': {
					color: '#5DCD3E',
				},
			},
			'cssUnderline-#5DCD3E': {
				'&:after': {
					borderBottomColor: '#5DCD3E',
				},
			},
			'cssInput-#5DCD3E': {
				color: '#5DCD3E',
			},

			'cssLabel-#052992': {
				'&$cssFocused': {
					color: '#052992',
				},
			},
			'cssUnderline-#052992': {
				'&:after': {
					borderBottomColor: '#052992',
				},
			},
			'cssInput-#052992': {
				color: '#052992',
			},
		}))(
			class CustomAttributes extends Component {
				state = {
					typing: false,
					anchorEl: null,
					customAttribute: null,
				}

				handleChange = (customAttribute, type, value) => {
					clearTimeout(this.timeout)
					this.props.onChange(customAttribute, type, value)
					this.setState({ typing: customAttribute })
					this.timeout = setTimeout(() => {
						this.props.createOrUpdateContact().then(
							(payload) => {
								if (
									this.props.history.location.pathname.slice(0, 13) ===
									'/contacts/new'
								) {
									this.props.history.replace(`/contacts/${payload.id}`)
								}
							},
							(err) => {
								return
							},
						)
						this.setState({ typing: false })
					}, 500)
				}

				render() {
					const { customAttributes, openAddDetailsModal, error } = this.props

					return (
						<div>
							<FormHelperText error={error}>{error}</FormHelperText>
							<div style={{ fontSize: 12 }}>
								{language.contacts.add.helperText.attributeDescription}
							</div>
							<div
								style={{ maxHeight: 250, paddingRight: 5, overflowY: 'auto' }}
							>
								{Object.keys(customAttributes).map((customAttribute, idx) => {
									const type = Object.keys(
										customAttributes[customAttribute].value,
									)[0]

									const value =
										typeof customAttributes[customAttribute].value[
											Object.keys(customAttributes[customAttribute].value)[0]
										] !== 'undefined'
											? customAttributes[customAttribute].value[
													Object.keys(
														customAttributes[customAttribute].value,
													)[0]
											  ].toString()
											: ''

									return (
										<div
											style={{
												position: 'relative',
												width: 'calc(100% - 34px)',
											}}
										>
											<FormControl
												key={`${customAttribute}`}
												fullWidth
												style={{ marginBottom: 15 }}
											>
												<InputLabel htmlFor={`${customAttribute}`}>
													{`${customAttribute}`}
												</InputLabel>
												<Input
													fullWidth
													onChange={(e) =>
														this.handleChange(
															customAttribute,
															type,
															e.target.value,
														)
													}
													value={value}
													id={`${customAttribute}`}
													inputComponent={
														type === 'N' ? TextMaskCustom : 'input'
													}
												/>
												{this.state.typing === customAttribute ? (
													<LinearProgress color="secondary" />
												) : null}
											</FormControl>
											<IconButton
												aria-owns={
													this.state.anchorEl
														? 'custom-field-delete-menu'
														: undefined
												}
												aria-haspopup="true"
												onClick={(e) => {
													// console.log(customAttribute)
													this.setState({
														anchorEl: e?.currentTarget,
														customAttribute,
													})
												}}
												style={{
													padding: 5,
													position: 'absolute',
													right: -34,
													top: 8,
												}}
											>
												<MoreVert />
											</IconButton>
										</div>
									)
								})}
								<Menu
									id="custom-field-delete-menu"
									open={Boolean(this.state.anchorEl)}
									anchorEl={this.state.anchorEl}
									onClose={() => this.setState({ anchorEl: null })}
								>
									<MenuItem
										onClick={() => {
											this.setState({ anchorEl: null })
											console.log(this.state.customAttribute)
											Promise.resolve(
												this.props.removeCustomAttribute(
													this.state.customAttribute,
												),
											).then(() => this.props.createOrUpdateContact())
										}}
									>
										<Delete style={{ color: '#808080', marginRight: 7 }} />
										{`Delete ${this.state.customAttribute}`}
									</MenuItem>
								</Menu>
							</div>
							<Button
								variant="outlined"
								color="secondary"
								onClick={openAddDetailsModal}
							>
								<Add />
								{language.contacts.add.newButton}
							</Button>
						</div>
					)
				}
			},
		),
	),
)
